import { cn } from '@smena/ui';

// Вкладки карточки аккаунта. Состояние держит вызывающий (обычно - в URL-параметре),
// чтобы ссылка на конкретную вкладку была отправляемой коллеге.

export interface TabItem {
  key: string;
  label: string;
  /** Число рядом с названием: сколько эскалаций / диалогов и т.п. */
  badge?: number;
}

export function Tabs({
  items,
  value,
  onChange,
}: {
  items: TabItem[];
  value: string;
  onChange: (key: string) => void;
}) {
  return (
    <div role="tablist" className="mb-4 flex gap-1 border-b border-line">
      {items.map((t) => {
        const active = t.key === value;
        return (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(t.key)}
            className={cn(
              '-mb-px border-b-2 px-3 py-2 text-sm transition-colors',
              active
                ? 'border-accent text-accent-fg'
                : 'border-transparent text-muted hover:text-text',
            )}
          >
            {t.label}
            {t.badge ? (
              <span className="ml-1.5 rounded-full bg-panel2 px-1.5 py-0.5 text-[10px] text-muted">
                {t.badge}
              </span>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
